export class QuickRegistrationPhone {
    private form: HTMLFormElement;
    private phoneInput: HTMLInputElement;
    private phoneMsg: HTMLElement;
    private phoneMarketingCheckbox: HTMLInputElement | null;
    private smsMarketingCheckbox: HTMLInputElement | null;

    constructor(form: HTMLFormElement) {
        this.form = form;
        this.phoneInput = form.querySelector('input[name="quickRegistrationRequest.PhoneNumber"]') as HTMLInputElement;
        this.phoneMsg = form.querySelector('#phone-number-validation') as HTMLElement;
        this.phoneMarketingCheckbox = form.querySelector('#phone-marketing') as HTMLInputElement | null;
        this.smsMarketingCheckbox = form.querySelector('#sms-marketing') as HTMLInputElement | null;

        if (!this.phoneInput || !this.phoneMsg) return;

        this.bindEvents();
    }

    private isPhoneRequired(): boolean {
        return (this.phoneMarketingCheckbox?.checked || false) ||
            (this.smsMarketingCheckbox?.checked || false);
    }

    private showError(): void {
        this.phoneMsg.textContent = "Phone number is required when Phone or SMS Marketing is selected.";
        this.phoneMsg.className = "error-message";
        this.phoneMsg.style.display = "";
        this.phoneInput.classList.add("input-validation-error");
        this.phoneInput.focus();
    }

    private clearError(): void {
        this.phoneMsg.textContent = "";
        this.phoneMsg.className = "";
        this.phoneMsg.style.display = "none";
        this.phoneInput.classList.remove("input-validation-error");
    }

    private bindEvents(): void {
        this.phoneMarketingCheckbox?.addEventListener("change", () => this.clearError());
        this.smsMarketingCheckbox?.addEventListener("change", () => this.clearError());

        this.form.addEventListener("submit", (e: Event) => {
            if (this.isPhoneRequired() && this.phoneInput.value.trim() === "") {
                e.preventDefault();
                e.stopImmediatePropagation();
                this.showError();
                return false;
            }

            this.clearError();
        });
    }
}
